import { useAtomValue } from 'jotai';
import { useEffect } from 'react';
import { useMap } from '@/features/map';
import { trailsVisibilityAtom } from './trailsAtom';
import { TRAIL_LAYERS } from './trailsStyle';

/** Shows or hides the trail layers. */
export function TrailsSync() {
  const map = useMap();
  const visible = useAtomValue(trailsVisibilityAtom) === 'on';

  useEffect(() => {
    if (!map) return;
    for (const id of TRAIL_LAYERS) map.setLayoutProperty(id, 'visibility', visible ? 'visible' : 'none');
  }, [map, visible]);

  return null;
}
